<div class="header px-3 py-2 d-flex justify-content-between align-items-center">
    <h4 class="mb-0 header__title text-capitalize">{{pageTitle}}</h4>
    @if((userRole === 0 || userRole === 1 || userRole === 99) && pageTitle.toLowerCase() === 'dashboard'){
        <app-master-search></app-master-search>
    }
    <div class="d-flex align-items-center">
        <app-quick-notification></app-quick-notification>
        <div class="d-flex align-items-center header__user" [matMenuTriggerFor]="orgListDisplay.length > 1? userBadge : userBadge2">
            <img [src]="profileImg" alt="" class="header__avatar" />
            <div class="ps-2">
                @if(userName){
                    <p class="mb-0 header__name text-capitalize">{{userName}}</p>
                    <p class="mb-0 header__profile">{{displayRole}}</p>
                    @if(currentProfile === 1 || userRole === 2 || userRole === 3){
                            <p class="mb-0 header__inspect" [style.color]="lobColor">
                                @if(orgListDisplay.length > 1){
                                <span>{{labels.header.inspect}}:</span>
                                }
                                {{currentOrgDisplay}}
                                @if(orgInfo){
                                    <br />
                                    {{orgInfo.threeplName}}
                                }
                            </p>
                    }
                    @else {
                        <p class="mb-0 header__inspect text-capitalize" [style.color]="lobColor">{{currentLobDisplay.toLocaleLowerCase()}}</p>
                    }
                }
            </div>
        </div>
        @if(orgInfo){
            <div class="header__orgInfo">
                <p>
                    <span class="header__orgInfoRow"><i class="bi bi-person header__cardIcons"></i> {{orgInfo.managerName}}</span>
                    <span class="header__orgInfoRow"><i class="bi bi-telephone header__cardIcons"></i> {{orgInfo.managerContact}}</span>
                    <span class="header__orgInfoRow"><i class="bi bi-envelope header__cardIcons"></i> {{orgInfo.managerEmail}}</span>
                </p>
                <p>
                    <span class="header__orgInfoRow"><i class="bi bi-geo-alt header__cardIcons"></i> {{orgInfo.threeplAddress}}</span>
                </p>
            </div>
        }
    </div>
    
    <mat-menu #userBadge="matMenu" xPosition="after" class="header__menu">
        <div class="p-3" (click)="$event.stopPropagation()">
            @if(userRole !== 2 || userRole !== 3){
                <p class="mb-0 font-14">{{labels.header.switchText}}</p>
            }
            @else {
                @if(orgListDisplay.length > 1){
                    <p class="mb-0 font-14">{{labels.header.switchText}}</p>
                }
            }
               
            <div class="d-flex align-items-center">
                <p class="mb-0 font-14">{{labels.header.switch}}</p>
                <div class="flex-fill ms-2 d-flex">
                    <div>
                        @if(userRole === 0 || userRole === 1 || userRole === 99){
                            <mat-form-field class="mb-1" style="width: 220px;">
                                <mat-select [(ngModel)]="currentLob" (selectionChange)="changeLob()">
                                    @for(lob of lobList; track lob){
                                        <mat-option [value]="lob">{{lob}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                        <mat-form-field style="width: 220px;">
                            <mat-select [(ngModel)]="currentOrg">
                                @for(org of orgListDisplay; track org){
                                    <mat-option [value]="org.threeplId" style="font-size: 12px">
                                        <span class="d-none">{{org.threeplName}}</span>
                                        {{org.threeplId}}@if(org.threeplName){ - }{{org.threeplName}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <button type="button" class="btn btn-sm ms-1 header__goBtn" [disabled]="!(currentLob && currentOrg)" (click)="redirectOrg()">{{labels.header.switchCta}}</button>
                </div>
            </div>
        </div>
        <button type="button" id="logoutBtnTest1" class="header__logout" (click)="logout()">{{labels.header.logout}}</button>
    </mat-menu>

    <mat-menu #userBadge2="matMenu" xPosition="after" class="header__menu">
        <button type="button" id="logoutBtnTest1" class="header__logout" (click)="logout()">{{labels.header.logout}}</button>
    </mat-menu>
</div>